import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, Popover } from "@mui/material";

const MRC_APPROVAL_AMOUNT_HINT_ROWS = [
  {
    sr: 1,
    role: "SDO",
    amount: "Rs.1/- to Rs.50,000/-",
  },
  {
    sr: 2,
    role: "XEN (O) Concerned",
    amount: "Rs.50,000/- to Rs.300,000/-",
  },
  {
    sr: 3,
    role: "SE (O) Concerned",
    amount: "Rs.300,000/- to Rs.10,00,000/-",
  },
  {
    sr: 4,
    role: "GM. (C & CS) Of Company",
    amount: "Rs.10,00,000/- to Above",
  },
];

/** Info hint: who performs the step + eOps role vs max bill amount */
const MrcApprovalAmountHint = ({ whoMessage } = {}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        type="button"
        size="small"
        className="mrc-approval-hint-btn"
        aria-label={whoMessage || "View approval amount limits"}
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(open ? null : e.currentTarget);
        }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        marginThreshold={12}
        disableScrollLock
        PaperProps={{ className: "mrc-approval-hint-popover" }}
      >
        <div className="mrc-approval-hint-wrap">
          {whoMessage ? (
            <p className="mrc-approval-hint-who">{whoMessage}</p>
          ) : null}
          <table className="mrc-approval-hint-table">
            <thead>
              <tr>
                <th>SR NO.</th>
                <th>eOps Role</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {MRC_APPROVAL_AMOUNT_HINT_ROWS.map((row) => (
                <tr key={row.sr}>
                  <td>{row.sr}</td>
                  <td>{row.role}</td>
                  <td>{row.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Popover>
    </>
  );
};

export default MrcApprovalAmountHint;
